document.addEventListener('DOMContentLoaded', function() {
  var header = document.querySelector('.header-transparent,.header-transparent-lg');

  if (!header) return;

  window.addEventListener('scroll', function() {
    if (window.scrollY > 0) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  }, { passive: true });
});